if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        if (window.location.href.includes("/products/")) {
          this.addRecentlyViewed();
        }
        this.input = this.querySelector(".quantity__input");
        this.currentVariant = this.querySelector(".product-variant-id");
        this.variantSelects = this.querySelector("variant-radios");
        this.submitButton = this.querySelector('[type="submit"]');
        this.mql = window.matchMedia("(min-width: 751px)");
        this.productPolicies = document.querySelectorAll(".product__policies");
        this.productPolicies.forEach((p) => {
          p.addEventListener("click", this.viewProductPolicy.bind(this, p));
        });
        if (document.querySelector("#product__sku").value.startsWith("GDL")) {
          this.callMtoListeners();
        }
        this.addon_price = 0;
        this.addon_compare_at_price = 0;
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            const sectionId = this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section;
            if (event.data.sectionId !== sectionId) return;
            this.updateQuantityRules(event.data.sectionId, event.data.html);
            this.setQuantityBoundries();
          }
        );
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity
            ? parseInt(this.input.dataset.cartQuantity)
            : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector(
          ".quantity__rules-cart .loading-overlay"
        ).classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`
        )
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector(
              ".quantity__rules-cart .loading-overlay"
            ).classList.add("hidden");
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null)
                current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      viewProductPolicy(policy) {
        if (!this.mql.matches) {
          document.querySelectorAll(
            ".product_form_fixed_buttons"
          )[0].style.display = "none";
          document.querySelectorAll(".product__inventory")[0].style.display =
            "none";
        }
        const activePolicy = document.getElementsByClassName(
          "active_product_policy"
        )[0];
        const tag = policy.querySelector(".tag");
        activePolicy.querySelector(".tag").innerHTML = tag.innerHTML;
        Array.from(activePolicy.getElementsByTagName("img")).forEach(
          (element) => {
            element.style.display = "none";
          }
        );
        if (tag.innerHTML === "100% Certified Lab Diamonds") {
          activePolicy.querySelector("#overlay_100_diamond").style.display =
            "block";
          activePolicy.querySelector("p").innerHTML =
            "Top-quality, eco-friendly premium lab-grown diamonds, certified by SGL/IGI.";
        } else if (tag.innerHTML === "BIS Hallmark") {
          activePolicy.querySelector("#overlay_bis").style.display = "block";
          activePolicy.querySelector("p").innerHTML =
            "100% purity assured with the BIS hallmark on all our gold jewellery.";
        } else if (tag.innerHTML === "Lifetime Exchange &amp; Buyback") {
          activePolicy.querySelector("#overlay_buyback").style.display =
            "block";
          activePolicy.querySelector("p").innerHTML =
            "Guaranteed lifetime exchange and buyback for GIVA gold and diamonds at current market prices.";
        } else if (tag.innerHTML === "Easy 30 Day Return") {
          activePolicy.querySelector("#overlay_30_days").style.display =
            "block";
          activePolicy.querySelector("p").innerHTML =
            "Don't worry, we offer a no-questions-asked, easy 30-day return policy for GIVA jewellery.";
        } else if (tag.innerHTML === "Lifetime Plating") {
          activePolicy.querySelector("#overlay_plating").style.display =
            "block";
          activePolicy.querySelector("p").innerHTML =
            "GIVA promises everlasting shine with the free lifetime plating service on silver jewellery.*";
        } else if (tag.innerHTML === "6-Month Warranty") {
          activePolicy.querySelector("#overlay_warranty").style.display =
            "block";
          activePolicy.querySelector("p").innerHTML =
            "Enjoy added assurance with our 6-month warranty on all of GIVA’s silver jewellery.";
        } else if (tag.innerHTML === "Fine 925 Silver") {
          activePolicy.querySelector("#overlay_925").style.display = "block";
          activePolicy.querySelector("p").innerHTML =
            "Get an assured 925 silver authenticity certificate with every piece of our silver jewellery.";
        } else if (tag.innerHTML === "999 Silver") {
          activePolicy.querySelector("p").innerHTML =
            "Purity guaranteed - get an assured 999 silver authenticity certificate.";
        }
        activePolicy.style.display = "flex";
        if (this.mql.matches) {
          activePolicy && activePolicy.addEventListener("click", () => {
            activePolicy.style.display = "none";
          });
        } else {
          activePolicy.querySelector("#cross") && activePolicy.querySelector("#cross").addEventListener("click", () => {
            activePolicy.style.display = "none";
            document.querySelectorAll(
              ".product_form_fixed_buttons"
            )[0].style.display = "block";
            document.querySelectorAll(".product__inventory")[0].style.display =
              "flex";
          });
        }
      }

      async addRecentlyViewed() {
        console.log("adding")
        const itemHandle =
          document.getElementsByClassName("product__title")[0].id;
        let finalItems = [];
        if (__st.cid) {
          const items = await fetch(
            `https://givadiva.co/v2/omnichannel/viewedProducts?user_shopify_id=${__st.cid}`
          ).then((res) => res.json());
          finalItems = items.data;
          if (!items.data.includes(itemHandle)) {
            fetch("https://givadiva.co/v2/omnichannel/productView", {
              method: "POST",
              body: JSON.stringify({
                user_shopify_id: `${__st.cid}`,
                handle: itemHandle,
              }),
              headers: { "Content-Type": "application/json" },
            }).then((e) => {
              console.log(e);
            });
          }
        }
        let recentlyViewedList = [];
        if (localStorage.getItem("recentlyViewedObj")) {
          recentlyViewedList = localStorage
            .getItem("recentlyViewedObj")
            .split(",");
          finalItems = recentlyViewedList;
          if (recentlyViewedList.includes(itemHandle)) {
            recentlyViewedList.splice(
              recentlyViewedList.indexOf(itemHandle),
              1
            );
          }
          if (recentlyViewedList.length === 10) {
            recentlyViewedList.shift();
          }
        }
        recentlyViewedList.push(itemHandle);
        localStorage.setItem("recentlyViewedObj", recentlyViewedList);
        if (finalItems.length > 0) {
          const element = document.getElementById("Slider-recently-viewed");
          Promise.allSettled(
            finalItems.map((p) =>
              fetch(`/products/${p}?view=card`)
                .then((r) => r.text())
                .then((res) => {
                  const text = res;
                  const parser = new DOMParser();
                  const htmlDocument = parser.parseFromString(
                    text,
                    "text/html"
                  );
                  const productCard =
                    htmlDocument.documentElement.querySelector(
                      ".template-card"
                    );
                  if (productCard) {
                    return productCard.innerHTML;
                  } else {
                    return null;
                  }
                })
            )
          ).then((cards) => {
            const finalProds = cards.filter((s) => s.value != null);
            if (finalProds.length > 0) {
              document.getElementsByClassName(
                "recently-viewed-prods"
              )[0].style.display = "block";
              finalProds.forEach((prod, index) => {
                const finalHtml = `<li
                  class="grid__item slider__slide{% if settings.animations_reveal_on_scroll %} scroll-trigger animate--slide-in{% endif %}"
                  id="Slide-recently-viewed-${index}"
                  {% if settings.animations_reveal_on_scroll %}
                    data-cascade
                    style="--animation-order: ${index};"
                  {% endif %}
                >
                  ${prod.value}
                </li>`;
                element.innerHTML += finalHtml;
              });
              const customSlider = document.getElementById(
                "recently_viewed_component"
              );
              if (
                customSlider &&
                typeof customSlider.initSlider === "function"
              ) {
                customSlider.initSlider();
              }
            } else {
              document.getElementsByClassName(
                "recently-viewed-prods"
              )[0].style.display = "none";
            }
          });
        } else {
          document.getElementsByClassName(
            "recently-viewed-prods"
          )[0].style.display = "none";
        }
      }

      openCustomPopup() {
        this.getMtoDetails(document.querySelector("#product__id").value);
        document.querySelector(".customisation_popup").style.display = "flex";
        if (!this.mql.matches) {
          document.querySelectorAll(
            ".product_form_fixed_buttons"
          )[0].style.display = "none";
        }
        const container = document.querySelector('.size_options');
        if (container && container.querySelector('.active_option')) {
          const targetPosition = container.querySelector('.active_option').offsetLeft;
          container.scroll({
            left: targetPosition,
            behavior: 'smooth'
          });
        }
        if (document.querySelector('.product-form__error-message-wrapper')) {
          document.querySelector('.product-form__error-message-wrapper').style.display = 'none';
        }
      }

      closeCustomPopup() {
        document.querySelector(".customisation_popup").style.display = "none";
        if (!this.mql.matches) {
          document.querySelectorAll(
            ".product_form_fixed_buttons"
          )[0].style.display = "block";
        }
      }

      openSizeGuide() {
        if (!this.mql.matches) {
          document.querySelector(".customisation_popup").style.display = "none";
          document.querySelector(".ring-size-guide-overlay").style.display = "flex";
        } else {
          document.querySelector(".ring-size-guide-overlay").style.display = "flex";
        }
      }

      closeSizeGuide() {
        document.querySelector(".customisation_popup").style.display = "flex";
        document.querySelector(".ring-size-guide-overlay").style.display = "none";
      }

      getMtoDetails(productId) {
        fetch(
          `https://givadiva.co/v2/products/goldCustomizationOptions?id=${productId}`
        )
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            let size_value = 0;
            let metal_value = '';
            let color_value = '';
            data.data.forEach((element) => {
              if (element.title.includes("size")) {
                const sizeDiv = document.querySelector(".size_options");
                size_value = this.generateOptions(sizeDiv, element.options);
              }
              if (element.title.includes("Metal")) {
                const metalDiv = document.querySelector(".metal_options");
                metal_value = this.generateOptions(metalDiv, element.options);
              }
              if (element.title.includes("Colour")) {
                const colorDiv = document.querySelector(".color_options");
                color_value = this.generateOptions(colorDiv, element.options);
              }
            });
            this.setMtoPrice(metal_value, color_value, size_value, productId);

            document.querySelectorAll('.custom_select_option').forEach(option => {
              option.addEventListener('click', () => {
                const parent = option.closest('.custom_select_options');
                const siblings = parent.querySelectorAll('.custom_select_option');
                siblings.forEach(sibling => sibling.classList.remove('active_option'));
                option.classList.add('active_option');
                const allHeads = document.querySelectorAll('.custom_select_options');
                if (option.querySelector('.custom_select_stock').dataset.stock === 'no') {
                  allHeads.forEach(head => {
                    if (head != option.closest('.custom_select_options')) {
                      head.querySelectorAll('.custom_select_option').forEach(opt => {
                        if (opt.querySelector('.custom_select_stock').dataset.stock === 'yes') {
                          opt.querySelector('.custom_select_stock').innerHTML = "Made to order";
                          opt.querySelector('.custom_select_stock').style.color = "#333";
                          opt.querySelector('.custom_select_stock').style.fontWeight = "400";
                        }
                      });
                    }
                  });
                } else {
                  allHeads.forEach(head => {
                    if (head != option.closest('.custom_select_options')) {
                      head.querySelectorAll('.custom_select_option').forEach(opt => {
                        if (opt.querySelector('.custom_select_stock').dataset.stock === 'yes') {
                          opt.querySelector('.custom_select_stock').innerHTML = "In Stock";
                          let inventory_quantity = document.querySelector("#inv_quan").value;
                          if (inventory_quantity <= 5 && inventory_quantity > 0 && opt.querySelector('.custom_select_value').dataset.value.includes('_gold')) {
                            opt.querySelector('.custom_select_stock').innerHTML = "Only " + inventory_quantity + " left";
                            opt.querySelector('.custom_select_stock').style.color = "#E9708A";
                            opt.querySelector('.custom_select_stock').style.fontWeight = "700";
                          }
                        }
                      });
                    }
                  });
                }
                this.setMtoPrice(
                  document.querySelector('.metal_options').querySelector('.custom_select_option.active_option').querySelector('.custom_select_value').dataset.value,
                  document.querySelector('.color_options').querySelector('.custom_select_option.active_option').querySelector('.custom_select_value').dataset.value,
                  (document.querySelector('.size_options') && document.querySelector('.size_options').querySelector('.custom_select_option.active_option').querySelector('.custom_select_value').dataset.value),
                  productId
                );
              });
            });

            const container = document.querySelector('.size_options');
            if (container && container.querySelector('.active_option')) {
              const targetPosition = container.querySelector('.active_option').offsetLeft;
              container.scroll({
                left: targetPosition,
                behavior: 'smooth'
              });
            }
          })
          .catch((error) => {
            console.error("Error fetching MTO details:", error);
          });
      }

      generateOptions(mainDiv, options) {
        mainDiv.innerHTML = '';
        let active_option;
        let inventory_quantity = document.querySelector("#inv_quan").value;
        options.forEach((option) => {
          if (option.is_default == true) {
            active_option = option.value;
          }
          const optionBox = document.createElement("div");
          optionBox.classList.add('custom_select_option');
          option.is_default == true ? optionBox.classList.add('active_option') : null;
          const curOption = document.createElement("div");
          curOption.classList.add('custom_select_value');
          curOption.innerHTML = option.label;
          curOption.dataset.value = option.value;
          const stockOption = document.createElement("div");
          stockOption.classList.add('custom_select_stock');
          stockOption.innerHTML = option.stock;
          stockOption.innerHTML = (option.is_default == true && inventory_quantity > 0) ? "In Stock" : "Made to order";
          stockOption.dataset.stock = (option.is_default == true && inventory_quantity > 0) ? "yes" : "no";
          if (inventory_quantity <= 5 && inventory_quantity > 0 && option.value.includes('_gold') && option.is_default == true) {
            stockOption.innerHTML = "Only " + inventory_quantity + " left";
            stockOption.style.color = "#E9708A";
            stockOption.style.fontWeight = "700";
          }
          optionBox.appendChild(curOption);
          optionBox.appendChild(stockOption);
          mainDiv.appendChild(optionBox);
        });
        if (!active_option) {
          const firstOption = mainDiv.querySelector('.custom_select_option:first-child');
          if (firstOption) {
            active_option = firstOption.querySelector('.custom_select_value').dataset.value;
            firstOption.classList.add('active_option');
          }
        }
        return active_option;
      }

      setMtoPrice(metal, color, size, id) {
        const payload = {};
        if (size != 0) {
          payload.size = size;
        }
        payload.metal = metal;
        payload.color = color;
        payload.id = id;
        fetch(
          'https://givadiva.co/v2/products/goldCustomizationPrice',
          {
            method: "POST",
            body: JSON.stringify(payload),
            headers: { "Content-Type": "application/json" }
          }
        )
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            this.addon_price = data.data.additional_price;
            this.addon_compare_at_price = data.data.additional_compare_at_price;
            const ogParent = document.querySelector(".custom-sale-price-og").parentElement;
            const fakeParent = document.querySelector(".custom-sale-price-fake").parentElement;
            document.querySelector(".custom-sale-price-fake").textContent = this.addCustomPrice(document.querySelector("#product__saleprice").value, data.data.additional_price);
            document.querySelector(".custom-regular-price-fake").textContent = this.addCustomPrice(document.querySelector("#product__regularprice").value, data.data.additional_compare_at_price);
            ogParent.style.transition = "transform 0.3s ease";
            fakeParent.style.transition = "transform 0.3s ease";
            ogParent.style.transform = "translateY(-100%)";
            fakeParent.style.transform = "translateY(-100%)";
            setTimeout(() => {
              document.querySelector(".custom-sale-price-og").textContent = this.addCustomPrice(document.querySelector("#product__saleprice").value, data.data.additional_price);
              document.querySelector(".custom-regular-price-og").textContent = this.addCustomPrice(document.querySelector("#product__regularprice").value, data.data.additional_compare_at_price);
              ogParent.style.transition = "none";
              fakeParent.style.transition = "none";
              ogParent.style.transform = "translateY(0)";
              fakeParent.style.transform = "translateY(0)";
            }, 350);
          });
      }

      addCustomPrice(price, valueToAdd) {
        let numericValue = parseFloat(price.replace(/[^0-9.]/g, ''));
        let newValue = numericValue + valueToAdd;
        return "₹" + newValue.toLocaleString('en-IN', { minimumFractionDigits: 2 });
      }

      displayCheckEDT() {
        document.querySelector(".custom_edt_box").style.display = "block";
        document.querySelector(".custom_edt_btn").style.color = "rgba(125, 125, 125, 1)";
      }

      checkEDT(pincode) {
        const sku = document.querySelector("#product__sku").value;
        const url = `https://prod.giva-api.com/getDeliveryTime?${sku.includes("PR") ? "perfume=true&" : ""
          }pin=${pincode}&sku=${sku}${sku.includes("PX") ? "&isPersonalised=true" : ""
          }&isMto=yes`;
        if (pincode.trim().length < 1) {
          document.querySelector(".edt-error").style.display = "block";
          return;
        }
        fetch(url)
          .then((response) => response.json())
          .then((response) => {
            if (response.status == 500) {
              document.querySelector(".edt-error").style.display = "block";
            } else {
              document.querySelector(".edt-error").style.display = "none";
              document.querySelector(".custom_edt_box").style.display = "none";
              document.querySelector(".check-edt").innerHTML = "Free Delivery By <strong>" + response.message.split("by ")[1] + "</strong>";
              document.querySelector(".check-edt").style.color = "rgba(125, 125, 125, 1)";
              document.querySelector(".check-edt-info").innerHTML = "Custom creations take a bit<br>more time, but the results are<br>worth the wait!";
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }

      buyMTOProduct() {
        if (
          document.querySelector('.metal_options').querySelector('.custom_select_option.active_option').querySelector('.custom_select_stock').textContent === 'Made to order' ||
          document.querySelector('.color_options').querySelector('.custom_select_option.active_option').querySelector('.custom_select_stock').textContent === 'Made to order' ||
          (document.querySelector('.size_options') && document.querySelector('.size_options').querySelector('.custom_select_option.active_option').querySelector('.custom_select_stock').textContent === 'Made to order')
        ) {
          let payload = {
            "product_id": document.querySelector("#product__id").value,
            "sku": document.querySelector("#product__sku").value,
            "listing_price": document.querySelector("#product__saleprice2").value,
            "addon_price": this.addon_price,
            "addon_compare_at_price": this.addon_compare_at_price,
            "customization": {
              "color": document.querySelector('.color_options').querySelector('.custom_select_option.active_option').querySelector('.custom_select_value').dataset.value,
              "metal": document.querySelector('.metal_options').querySelector('.custom_select_option.active_option').querySelector('.custom_select_value').dataset.value.replace('k', '')
            },
            "user_shopify_id": __st.cid ? __st.cid : null,
            "user_email": (document.getElementById("cust__email").value.length > 0) ? document.getElementById("cust__email").value : null,
          };
          if (document.querySelector('.size_options')) {
            payload.customization.size = document.querySelector('.size_options').querySelector('.custom_select_option.active_option').querySelector('.custom_select_value').dataset.value;
          }
          fetch(
            'https://givadiva.co/v2/features/mto/mtoWebTemp',
            {
              method: "POST",
              body: JSON.stringify(payload),
              headers: { "Content-Type": "application/json" }
            }
          )
            .then((response) => {
              return response.json();
            })
            .then((data) => {
              window.location.href = `https://mto.giva.co/cart/${data.data}`;
            });
        } else {
          document.querySelector(".product-form__atc").click();
          document.querySelector(".customisation_btn").style.opacity = "0.5";
          document.querySelector(".customisation_btn").style.pointerEvents = "none";
          setTimeout(() => {
            this.closeCustomPopup();
          }, 1000);
          setTimeout(() => {
            window.location.href = '/cart';
          }, 2000);
        }
      }

      callMtoListeners() {
        this.getMtoDetails(document.querySelector("#product__id").value);
        document.querySelector(".size-guide") && document.querySelector(".size-guide").addEventListener("click", () => {
          this.openSizeGuide();
        });
        document.querySelector("#guide-back") && document.querySelector("#guide-back").addEventListener("click", () => {
          this.closeSizeGuide();
        });
        document.querySelector("#guide-back-1") && document.querySelector("#guide-back-1").addEventListener("click", () => {
          this.closeSizeGuide();
        });
        document.querySelector(".mto_customize_open") && document.querySelector(".mto_customize_open").addEventListener("click", () => {
          this.openCustomPopup();
        });
        document.querySelector(".mto_customize_open_btn") && document.querySelector(".mto_customize_open_btn").addEventListener("click", () => {
          this.openCustomPopup();
        });
        document.querySelector("#close-customisation") && document.querySelector("#close-customisation").addEventListener("click", () => {
          this.closeCustomPopup();
        });
        document.querySelector(".custom-tooltip") && document.querySelector(".custom-tooltip").addEventListener("click", () => {
          document.querySelector('.tooltiptext').style.visibility = 'visible';
        });
        document.querySelector(".close-tooltip") && document.querySelector(".close-tooltip").addEventListener("click", (e) => {
          e.stopPropagation();
          document.querySelector('.tooltiptext').style.visibility = 'hidden';
        });
        document.querySelector(".check-edt") && document.querySelector(".check-edt").addEventListener("click", () => {
          this.displayCheckEDT();
        });
        document.querySelector(".custom_edt_btn") && document.querySelector(".custom_edt_btn").addEventListener("click", () => {
          this.checkEDT(document.querySelector(".custom_edt_input").value);
        });
        if (document.querySelector("#cust_zip").value) {
          this.checkEDT(document.querySelector("#cust_zip").value);
        }
        document.querySelector(".customisation_btn") && document.querySelector(".customisation_btn").addEventListener("click", () => {
          this.buyMTOProduct();
        });
        document.addEventListener('DOMContentLoaded', () => {
          const queryParams = new URLSearchParams(window.location.search);
          if (queryParams.has('customize')) {
            this.openCustomPopup();
          }
        });
      }
    }
  );
}
